import React, { useEffect, useState } from "react";
import ReactLeafletKml from "react-leaflet-kml";

export const KmlLayer = ({ data }) => {
  const [kml, setKml] = useState(null);

  useEffect(() => {
    const fetchGeoData = async () => {
      fetch(data?.url)
        .then((res) => res.text())
        .then((text) => {
          const parser = new DOMParser();
          const resKml = parser.parseFromString(text, "text/xml");
          setKml(resKml);
        })
        .catch((error) => {});
    };
    data?.url && fetchGeoData();
  }, [data?.url]);

  if (kml) {
    return <ReactLeafletKml kml={kml} />;
  }

  return null;
};
